import React from 'react'
import { Link } from 'react-router-dom'
import './style.css'

function TopNavTest() {
  return (
    <div className='main-menu-nav'>
        <ul style={{ display: 'block'}}>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/services'>Services</Link></li>
            <li><Link to='/about'>About</Link></li>
            <li><Link to='/work'>Work</Link></li>
            <li><Link to='/pricing'>Price</Link></li>
        </ul>
    </div>
  )
}

export default TopNavTest